/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  exerciseMyPrivacyRightsOld: {
    name: 'Exercise_My_Privacy_Rights',
    componentName: 'ExerciseMyPrivacyRights',
    chunk: () => import(
      /* webpackChunkName: "Exercise_My_Privacy_Rights" */
      './pages/privacy/ExerciseMyPrivacyRights.js'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src//pages/privacy/ExerciseMyPrivacyRights.js')).ExerciseMyPrivacyRights
        : currentRouteName === 'Exercise_My_Privacy_Rights'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ExerciseMyPrivacyRights })));
    },
    path: '/:context?/privacy/Exercise_My_Privacy_Rights',
    channel: null
  },
  privacySecurityOld: {
    name: 'Privacy_Security',
    componentName: 'Security',
    chunk: () => import(
      /* webpackChunkName: "Privacy_Security" */
      './pages/privacy/Privacy-Security.js'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/privacy/Privacy-Security.js')).Security
        : currentRouteName === 'Privacy_Security'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Security })));
    },
    path: '/:context?/privacy/Privacy_Security',
    channel: null
  },
  californiaPrivacyRightsOld: {
    name: 'californiaPrivacyRights',
    componentName: 'Privacy',
    chunk: () => import(
      /* webpackChunkName: "California_Privacy_Rights" */
      './pages/privacy/Privacy-Rights.js'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/privacy/Privacy-Rights.js')).Privacy
        : currentRouteName === 'californiaPrivacyRights'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Privacy })));
    },
    path: '/:context?/privacy/California_Privacy_Rights',
    channel: null
  },
  exerciseMyPrivacyRights: {
    name: 'Exercise_My_Privacy_Rights',
    componentName: 'ExerciseMyPrivacyRights',
    chunk: () => import(
      /* webpackChunkName: "Exercise_My_Privacy_Rights" */
      './pages/privacy/ExerciseMyPrivacyRights.js'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src//pages/privacy/ExerciseMyPrivacyRights.js')).ExerciseMyPrivacyRights
        : currentRouteName === 'Exercise_My_Privacy_Rights'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ExerciseMyPrivacyRights })));
    },
    path: '/:context?/privacy/Exercise-My-Privacy-Rights',
    channel: null
  },
  privacySecurity: {
    name: 'Privacy_Security',
    componentName: 'Security',
    chunk: () => import(
      /* webpackChunkName: "Privacy_Security" */
      './pages/privacy/Privacy-Security.js'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/privacy/Privacy-Security.js')).Security
        : currentRouteName === 'Privacy_Security'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Security })));
    },
    path: '/:context?/privacy/Privacy-Security',
    channel: null
  },
  californiaPrivacyRights: {
    name: 'californiaPrivacyRights',
    componentName: 'Privacy',
    chunk: () => import(
      /* webpackChunkName: "California_Privacy_Rights" */
      './pages/privacy/Privacy-Rights.js'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/privacy/Privacy-Rights.js')).Privacy
        : currentRouteName === 'californiaPrivacyRights'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Privacy })));
    },
    path: '/:context?/privacy/California-Privacy-Rights',
    channel: null
  }
});
